<template>
  <footer>
    <div class="footer-container w">
      <div class="f-left">
        <div class="f-nav">
          <router-link to="/product-erp">产品中心</router-link>
          <span></span>
          <router-link to="/solve">解决方案</router-link>
          <span></span>
          <router-link to="/service">服务体系</router-link>
          <span></span>
          <router-link to="/case">经典案列</router-link>
        </div>
        <div class="f-info">
          <span>传真：0755-86577078</span>
          <span>公司地址：深圳市南山区数字文化产业基地西塔1007</span>
        </div>
        <!-- <div class="f-link">
          <svg-icon icon-class="icon_link" class-name="icon_link"></svg-icon>友情链接：
        </div>-->
      </div>
      <div class="f-right">
        <div class="f-contact">
          <img class="f-qr" src="~@/assets/imgs/weChat_qr.png" alt />
          <div class="f-tel">
            <svg-icon icon-class="icon_tel" class-name="icon_tel"></svg-icon>
            <div class="f-tel-view">
              <p class="f-tel-text">联系我们</p>
              <p class="f-tel-num">0755-86250886</p>
            </div>
          </div>
        </div>
        <div class="f-copy">
          <a href="http://www.beian.miit.gov.cn/">网站备案号：粤ICP备10230216号-1</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  background: #1b1f23;
  .footer-container {
    padding: 26px 0;
    @include clearfix;
    .f-left {
      width: 800px;
      height: 100%;
      float: left;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      .f-nav {
        > a {
          color: #fff;
        }
        span {
          display: inline-block;
          width: 1px;
          height: 15px;
          background: #fff;
          vertical-align: middle;
          margin: 0 24px;
        }
      }
      .f-info {
        margin-top: 16px;
        span {
          margin-right: 16px;
        }
      }
      .f-link {
        margin-top: 34px;
        .icon_link {
          margin-right: 5px;
        }
      }
    }
    .f-right {
      float: right;
      width: 420px;
      height: 100%;
      color: #fff;
      .f-contact {
        height: 70px;
        @include clearfix;
        .f-qr {
          width: 70px;
          height: 70px;
          float: left;
          margin-right: 48px;
        }
        .f-tel {
          padding: 8px 0;
          float: left;
          @include clearfix;
          .icon_tel {
            font-size: 54px;
            float: left;
          }

          .f-tel-view {
            float: left;
            margin-left: 10px;
            .f-tel-text {
              font-size: 12px;
              font-weight: 500;
              line-height: 16px;
            }
            .f-tel-num {
              font-size: 30px;
              font-weight: 500;
              line-height: 36px;
            }
          }
        }
      }
      .f-copy {
        line-height: 16px;
        margin-top: 24px;
        text-align: right;
        a {
          font-size: 12px;
          font-weight: 400;
          color: inherit;
        }
      }
    }
  }
}
</style>